// Note: GTM is now loaded manually via HTML script tag for better performance
// This service maintains the same API for backward compatibility

export const ResourcesTypes = {
  deadline: "deadline",
  document: "document",
  meeting: "meeting",
};

// Ensure dataLayer exists even if GTM hasn't loaded yet
const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

// Helper function to check if GTM is available
const isGTMAvailable = () => {
  return (
    typeof window !== "undefined" &&
    window.dataLayer &&
    Array.isArray(window.dataLayer)
  );
};

// Helper function to check if GTM script is loaded
const isGTMLoaded = () => {
  return !!(window.gtmLoaded || window.google_tag_manager);
};

// Get the Cookiebot object
const getCookiebotInstance = () => {
  return window.Cookiebot || null;
};

// Check if user has consented to statistics/marketing cookies
const hasConsent = () => {
  if (window.Cookiebot && window.Cookiebot.consent) {
    return (
      window.Cookiebot.consent.statistics || window.Cookiebot.consent.marketing
    );
  }
  return false;
};

// Helper function to safely push to dataLayer
const safeDataLayerPush = (data) => {
  ensureDataLayer();

  // Only push tracking events if user has given consent for statistics/marketing
  if (hasConsent()) {
    window.dataLayer.push(data);

    // If GTM isn't loaded yet but we have consent, try to load it
    if (!isGTMLoaded() && window.loadGTM) {
      window.loadGTM();
    }
  } else {
    // Store events to be sent later when consent is given
    window.pendingGTMEvents = window.pendingGTMEvents || [];
    window.pendingGTMEvents.push(data);
  }
};

// Function to flush pending events when consent is granted
const flushPendingEvents = () => {
  if (
    hasConsent() &&
    window.pendingGTMEvents &&
    window.pendingGTMEvents.length > 0
  ) {
    ensureDataLayer();
    window.pendingGTMEvents.forEach((event) => {
      window.dataLayer.push(event);
    });
    window.pendingGTMEvents = [];
  }
};

// Listen for consent events to flush pending tracking
if (typeof window !== "undefined") {
  window.addEventListener("CookiebotOnConsentReady", flushPendingEvents);
  window.addEventListener("CookiebotOnAccept", flushPendingEvents);
}

export default {
  initialize() {
    // GTM is now loaded conditionally based on consent
    // This method ensures dataLayer exists for queuing events
    ensureDataLayer();
  },

  setUser: (userId) => {
    safeDataLayerPush({
      event: "user.login",
      userId: userId,
    });
  },

  setUserLanguage: (lang) => {
    safeDataLayerPush({
      event: "user.language",
      language: lang,
    });
  },

  showDeleteDialog: (resourceType, resourceId) => {
    safeDataLayerPush({
      event: "notification.delete",
      notificationType: resourceType,
      notificationId: resourceId,
      action: "prompt",
    });
  },

  closeDeleteDialog: (resourceType, resourceId) => {
    safeDataLayerPush({
      event: "notification.delete",
      notificationType: resourceType,
      notificationId: resourceId,
      action: "cancel",
    });
  },

  deletionConfirmed: (resourceType, resourceId) => {
    safeDataLayerPush({
      event: "notification.delete",
      notificationType: resourceType,
      notificationId: resourceId,
      action: "delete",
    });
  },
};
